export default {
  title: 'Ultime 4 settimane',
  item_interval: '(1)[1 visita];(2)[2 visite];(3-5)[3-5 visite];(6-inf)[6+ visite];',
  total: 'Visitatori totali',
};
